export default "__VITE_ASSET__D76bFmjv__"